<script>
  import { Link } from "svelte-routing";
</script>

<svelte:head>
  <title>404 Not Found · 27types</title>
</svelte:head>

<header>
  <section>
    <h1><em>27types</em></h1>
  </section>
</header>
<main class='text-center'>
  <h2 class='display-1 mb-5'>404 · Page Not Found</h2>
  <section>
    <Link to="/">
      <button class="btn btn-primary shadow-sm"
        >Go to Homepage</button
      >
    </Link>
  </section>
</main>

<style>
</style>
